module.exports = __webpack_public_path__ + "static/media/users.08720c9f.svg";